var map = {
	"./mijn-gemeente_horizontaal_green_de.svg": 16921,
	"./mijn-gemeente_horizontaal_green_en.svg": 61073,
	"./mijn-gemeente_horizontaal_green_fr.svg": 51184,
	"./mijn-gemeente_horizontaal_green_nl.svg": 11262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55118;